var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdicionar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.74 18.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252529;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.95,18.61c-.19-.04-.39-.08-.58-.13C.98,18.08,0,16.81,0,15.38,0,11.69,0,8,0,4.31.01,2.06,1.75.23,4.06.02c2.14-.2,4.19,1.36,4.6,3.51.05.28.08.56.08.85,0,3.6,0,7.19,0,10.79v.17h-1.09c0-.08,0-.15,0-.23,0-3.57,0-7.13,0-10.7,0-1.61-1.08-2.93-2.66-3.25-1.82-.37-3.63.94-3.86,2.78-.02.14-.03.28-.03.42,0,3.66,0,7.33,0,10.99,0,1.2.98,2.17,2.18,2.18,1.2,0,2.19-.96,2.19-2.16,0-1.84,0-3.68,0-5.52,0-1.1,0-2.19,0-3.29,0-.44-.21-.78-.61-.98-.4-.2-.79-.15-1.15.12-.3.23-.42.55-.42.92,0,2.1,0,4.19,0,6.29,0,.8,0,1.61,0,2.43h-1.08s0-.1,0-.15c0-2.87,0-5.74,0-8.61,0-1.24,1-2.21,2.23-2.19,1.15.02,2.12.98,2.13,2.13.01.91,0,1.83,0,2.74,0,2.02,0,4.03,0,6.05,0,1.63-1.08,2.95-2.68,3.27-.09.02-.18.04-.26.05h-.66Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdicionar);
export default __webpack_public_path__ + "static/media/adicionar.6307c6dfffb03db157e0b5dea29f011c.svg";
export { ForwardRef as ReactComponent };